<template>
  <v-stepper-content v-bind="$attrs">
    <v-card>
      <v-card-title>
        Выберите мастер-лицензию
      </v-card-title>
      <v-card-text class="d-flex items-center justify-center" style="height: 150px" v-if="loading">
        <Loader label="Загрузка мастер-лицензий объекта"/>
      </v-card-text>
      <v-card-text v-else>
        <v-text-field
          v-model="search"
          color="green"
          label="Поиск"
          prepend-inner-icon="mdi-magnify"
          append-outer-icon="mdi-close"
          @click:append-outer="search=''"
          
        ></v-text-field>
        <v-data-table
          disable-pagination
          hide-default-footer
          single-select
          show-select
          :search="search"
          @item-selected="e => e.value ? $emit('input', e.item.id) : $emit('input', 0)"
          locale="ru-RU"
          no-data-text="Нет доступных мастер-лицензий"
          no-results-text="По вашему запросу ничего не найдено"
          :items="linked_masters"
          :headers="headers"
        >
          
        </v-data-table>
      </v-card-text>
      <v-card-actions v-if="!loading">
        <v-btn
          @click="$emit('back')"
          text
        >
          <v-icon small>mdi-arrow-left</v-icon>
          Назад
        </v-btn>

        <v-btn
          @click="$emit('next')"
          color="green"
          text
          :disabled="value == 0"
        >
          <v-icon small>mdi-page-next-outline</v-icon>
          Далее
        </v-btn>
        
        
      </v-card-actions>
    </v-card>
  </v-stepper-content>
</template>

<script>
import Loader from '../ui/Loader.vue'

export default {
  props:['value', 'object_id'],
  data: () => ({
    search: '',
    loading: false,
    masters: [],
    gsa: []

  }),
  watch:{
    object_id(val) {
      this.search = ''
      if (val) {
        this.load_masters()
        this.$emit('input', 0)
      } else {
        this.masters = []
        this.gsa = []
      }

    }
  },
  methods:{
    async load_masters(){
      this.loading = true
      let masters, gsa

      [masters, gsa] = await Promise.all([
        this.$store.dispatch('load_masters_by_object', this.object_id),
        this.$store.dispatch('load_gsa_by_object', this.object_id)
      ])

      this.masters = masters
      this.gsa = gsa

      console.log(this.masters, this.gsa)

      this.loading = false
    }
  },
  computed:{
    linked_masters(){
      return this.masters.map(el => {
        let a = {
          ...el,
          used: this.gsa.filter( gsa => gsa.master_id == el.id).length
        }

        a.isSelectable = a.used < a.count

        let expiration = new Date(a.expires)
        if (expiration <= new Date()) {
          return undefined
        }
        a.expires = expiration.toLocaleDateString('ru-RU')
        
        return a
      }).filter(el => el && !el.isDeleted)
    },
    headers() {
      return [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Модуль',
          value: 'moduleName'
        },
        {
          text: 'Количество',
          value: 'count'
        },
        {
          text: 'Ранее использовано',
          value: 'used'
        },
        {
          text: 'Истекает',
          value: 'expires'
        },
      ]
    }
  },
  components:{
    Loader,
  }
}
</script>